export default __webpack_public_path__ + "static/portfolio-mas-8-fc5d59ce19db23c77f6056f3bd8cec27.jpg";